import api from 'services/api';
import { flowChatRef } from 'v3/integrations/flowChat/FlowChatHost';

let loggingOut = null;

// Sair encerra antes a sessão do Flow Chat. Com o iframe criado, o pacote envia `sign-out` e
// espera `sign-out-done` até 2 s; sem iframe, resolve na hora. Um segundo clique durante a espera
// reaproveita a mesma saída.
export function logout() {
  loggingOut ??= signOut();
  return loggingOut;
}

async function signOut() {
  try {
    await flowChatRef.current?.signOutAndUnmount();
  } catch {
    // Falha do Flow não impede o logout do portal.
  }
  clearSession();
}

function clearSession() {
  localStorage.removeItem('currentClientId', null);
  localStorage.removeItem('currentClientName', null);
  localStorage.removeItem('token', null);
  localStorage.removeItem('usuario', null);
  localStorage.removeItem('permissions', null);
  localStorage.removeItem('travelsControlTowerUserColumnOrderPreference');
  localStorage.removeItem('userColumnSizingPreference');
  localStorage.removeItem('travelsControlTowerUserColumnSizingPreference');
  localStorage.removeItem('userColumnOrderPreference');
  localStorage.removeItem('travelsControlTowerUserPerPage');

  window.location.href = '/login';
}

export async function versionUpdate(versionTime) {
  try {
    if (versionTime) {
      await api.post('user/version/update', {
        version: versionTime,
      });
      const userJson = JSON.parse(localStorage.getItem('usuario'));
      const response = await api.get(`users/${userJson.id}`);
      localStorage.setItem('version', JSON.stringify(response.data.read_version));
    }
  } catch (ex) {
    // ex
  }
}
